import { STORAGE_KEY } from "@/constant/export/storage";
import { createRandomId } from "./randomId";

const CLIENT_ID_PREFIX = import.meta.env.VITE_ABLY_CLIENT_ID_PREFIX ?? "hpoll-user";

const generateConversationId = () => {
    return createRandomId("conv");
};

const buildAssistantClientId = (userId, conversationId) => {
    const safeUserId = (userId ?? "guest").toString().trim() || "guest";
    return `${CLIENT_ID_PREFIX}--${safeUserId}--${conversationId}`;
};

const resolveUserId = (userId) => {
    if (userId !== undefined && userId !== null && `${userId}`.trim() !== "") {
        return userId;
    }
    try {
        const storedUser = JSON.parse(localStorage.getItem(STORAGE_KEY.USER) || "{}");
        if (storedUser?.id !== undefined && storedUser?.id !== null) {
            return storedUser.id;
        }
    } catch {
    }
    return null;
};

const broadcastIdentityUpdate = (clientId, conversationId) => {
    if (typeof window === "undefined") return;
    window.dispatchEvent(
        new CustomEvent("assistant:identity-updated", {
            detail: { clientId, conversationId },
        }),
    );
};

export const ensureAssistantIdentity = ({
    userId,
    resetConversation = false,
    notify = false,
} = {}) => {
    const conversationId = generateConversationId();
    const resolvedUserId = resolveUserId(userId);
    const clientId = buildAssistantClientId(resolvedUserId, conversationId);
    if (notify) {
        broadcastIdentityUpdate(clientId, conversationId);
    }
    return { clientId, conversationId };
};

export const getStoredAssistantIdentity = () => ({
    clientId: null,
    conversationId: null,
});

export const createAssistantMessageId = () => {
    return createRandomId("msg");
};
